























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetTonguePreview } from "@/request/tongue";
import PicPreview from "@/components/pic-preview.vue";
import Shetubaogao from "./shetubaogao.vue";
import Dingxing from "./dingxing.vue";
import Yanse from "./yanse.vue";
import Jihe from "./jihe.vue";
import Wenli from "./wenli.vue";
import Fenzu from "./fenzu.vue";
@Component({
  components: {
    PicPreview,
    Shetubaogao,
    Dingxing,
    Yanse,
    Jihe,
    Wenli,
    Fenzu
  },
})
export default class TonguePreview extends Vue {
  private loaded: boolean = false;
  private tongueId: any = "";
  private r: any = {
    舌象照片: {},
  };
  private tempUrl: any = "";
  private ifShowPreview: boolean = false;
  private cState: any = "舌图报告";
  /**
   * @description 获取数据
   */
  private fetchResult() {
    this.loaded = false;
    const params: any = {
      params: {
        tongue_id: this.tongueId,
      },
    };
    GetTonguePreview(this, params).then((data: any) => {
      this.r = data;
      this.loaded = true;
    });
  }
  /**
   * @description 打开图片预览
   */
  private showPreview(src) {
    this.tempUrl = src;
    this.ifShowPreview = true;
  }
  /**
   * @description 改变显示部分
   */
  private changeState(state) {
    this.cState = state;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.tongue_id) {
      this.$message.error("参数有误");
      this.$router.back();
      return;
    }
    this.tongueId = this.$route.query.tongue_id;
    this.fetchResult();
  }
}
